import { render, staticRenderFns } from "./NewStoreCustomerData.vue?vue&type=template&id=27f4cdd0&scoped=true"
import script from "./NewStoreCustomerData.vue?vue&type=script&lang=js"
export * from "./NewStoreCustomerData.vue?vue&type=script&lang=js"
import style0 from "./NewStoreCustomerData.vue?vue&type=style&index=0&id=27f4cdd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4cdd0",
  null
  
)

export default component.exports